<template>
  <div class="my-6">
    <div class="flex items-center justify-between">
      <h3 class="text-root-2 font-medium"></h3>
      <div class="md:flex items-center gap-x-3">
        <div
          class="grid grid-cols-2 lg:flex lg:items-center lg:justify-between gap-x-2"
        >
          <!-- search functionality not working yet -->
          <div class="md:pb-1 pb-0">
            <!-- <el-form>
              <el-form-item class="lg:w-302px">
                <el-input
                  class="w-full"
                  v-model="search"
                  @search="searchResult"
                  placeholder="Search"
                >
                  <i
                    slot="prefix"
                    :size="40"
                    class="el-input__icon el-icon-search"
                  ></i>
                </el-input>
              </el-form-item>
            </el-form> -->
          </div>
        </div>
        <!-- <el-button
          class="px-4 w-2/4 lg:w-full lg:py-4 py-2.5 flex items-center justify-center gap-x-2 bg-primary text-white shadow-sm rounded-lg mb-6 font-light"
        >
          <div class="flex items-center gap-x-2">
            <upload-icon />
            <span class="text-xs lg:text-base">Export CSV</span>
          </div>
        </el-button> -->
      </div>
    </div>
    <div>
      <div class="mt-6" v-if="isLoading">
        <spinner />
      </div>
      <div v-else>
        <el-table
          class="relative cursor-pointer font-normal text-root-2 text-xs lg:text-sm"
          index
          :data="tableData"
          style="width: 100%"
          max-height="500"
          @row-click="handleRowClick"
        >
          <el-table-column class="w-full" :width="columnWidth">
            <template slot="header">
              <div
                class="flex items-center justify-between py-2 px-2 lg:px-5 font-medium"
              >
                <p
                  style="word-break: normal"
                  class="text-root-2 text-xs lg:text-sm"
                >
                  BulkId
                </p>
              </div>
            </template>
            <template slot-scope="scope">
              <div
                class="flex items-center gap-x-3 font-light text-xs md:text-sm"
              >
                <span class="text-md">{{
                  scope.row.recurringBulkPayoutID || '--'
                }}</span>
                <span
                  class="cursor-pointer flex items-center"
                  v-clipboard:copy="scope.row.id"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  <copy-icon />
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column class="w-full" :width="columnWidth">
            <template slot="header">
              <div
                class="flex items-center justify-between py-2 px-2 lg:px-5 font-medium"
              >
                <p
                  style="word-break: normal"
                  class="text-root-2 text-xs lg:text-sm"
                >
                  Status
                </p>
              </div>
            </template>
            <template slot-scope="scope">
              <div class="flex items-center ml-3">
                <div
                  class="text-xs md:text-sm capitalize py-2 px-3 rounded-xl flex items-center justify-center shadow-sm"
                  :class="statusClass(scope.row.status)"
                >
                  {{ formatServerName(scope.row.status) || '--' }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column class="w-full" :width="columnWidth">
            <template slot="header">
              <div
                class="flex items-center justify-between py-2 px-2 lg:px-5 font-medium"
              >
                <p
                  style="word-break: normal"
                  class="text-root-2 text-xs lg:text-sm"
                >
                  Due Date
                </p>
              </div>
            </template>
            <template slot-scope="scope">
              <div class="font-medium flex text-sm md:text-sm">
                <div class="pl-2 font-light text-xs md:text-sm">
                  <span>
                    <el-tooltip
                      :content="tooltipDateContent(scope.row.dueDate)"
                      placement="top"
                      effect="light"
                    >
                      <span>
                        {{ displayTimeDate(scope.row) || '--' }}
                      </span>
                    </el-tooltip>
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="p-6 grid grid-cols-1 md:justify-items-end">
        <!--Pagination-->
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="page.size"
          @next-click="next"
          @prev-click="previous"
          background
          layout="prev, pager, next"
          :total="page.totalCount"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import statusClass from '@/mixins/app.js'
import breakpoints from '@/utils/breakpoints.js'

import {
  FormatServerName,
  ParseRelativeTime,
  AddComma,
  ParseLocalTime,
  ParseMoneyAll,
  MaskID
} from '@/utils/helpers.js'
export default {
  mixins: [statusClass],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    page: {
      type: Object,
      default: () => {}
    },
    isLoading: { type: Boolean, default: false },
    recurringLogDetails: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isCopyOnTable: false
    }
  },
  components: {
    // UploadIcon: () => import('@/assets/v2/icons/UploadIcon.vue'),
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue'),
    Spinner: () => import('@/components/v2/app/Spinner.vue')
  },
  methods: {
    maskID (id) {
      return MaskID(id)
    },
    parseRelativeTime (timeToPick) {
      return ParseRelativeTime(timeToPick)
    },
    parseTime (row) {
      return !this.isCompleted
        ? ParseLocalTime(row.createdAt) +
            '|' +
            this.$dayjs(row.createdAt).format('DD MMM YYYY')
        : ParseLocalTime(row.updatedAt) +
            '|' +
            this.$dayjs(row.updatedAt).format('DD MMM YYYY')
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    displayTimeDate (row) {
      const timeToPick =
        row.status === 'success' ? row.completedAt : row.dueDate
      return this.tooltipDateContent(timeToPick)
    },
    parseLocalTime (time) {
      return ParseLocalTime(time)
    },
    addComma (val) {
      return AddComma(val.toString())
    },
    formatServerName (val) {
      return FormatServerName(val)
    },
    next (val) {
      this.$emit('handleCurrentChange', { page: val })
    },
    previous (val) {
      this.$emit('handleCurrentChange', { page: val })
    },
    handleCurrentChange (val) {
      this.$emit('handleCurrentChange', { page: val })
    },
    closeDialog (dialog) {
      this[dialog] = false
    },
    handleRowClick (row) {
      if (!this.isCopyOnTable) {
        const id = row.bulkPayoutID
        this.$router.push(`/payout/${id}`)
      }
      this.isCopyOnTable = false
      this.$emit('toggleTableView', row)
    },
    onCopy: function (e) {
      this.isCopyOnTable = true
      this.$notify.success({
        title: 'Bulk ID copied successfully!'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    }
  },
  computed: {
    noTransactions () {
      return !this.tableData.length > 0
    },
    columnWidth () {
      return breakpoints.lgAndUp ? 'auto' : breakpoints.mdAndUp ? '220' : '170'
    }
  },
  mounted () {
    this.defaultPayload = { ...this.payload }
    this.defaultPayload.status = this.tableType
  }
}
</script>
<style scoped>
>>> .el-table {
  background: var(--background-surface);
  border: 1px solid var(--border-main) !important;
  border-radius: 12px;
}
>>> .el-table th {
  background: var(--background-surface);
  border-width: 0px 1px 1px 0px !important;
  border-style: solid;
  border-color: var(--border-main) !important;
}
>>> .el-table tr {
  background: var(--background-surface);
}
>>> li.number.active {
  background-color: var(--color-primary) !important;
  border: none !important;
  color: white !important;
  border-radius: 7.53065px !important;
}
>>> li.number {
  border: none !important;
  font-weight: 500;
  font-size: 12px;
  color: var(--text-2);
  background: transparent !important;
  /* color: var(--color-primary) !important ; */
}
>>> li.number:hover {
  border: 0.941331px solid var(--color-primary) !important;
  border-radius: 7.53065px !important;
  color: var(--text-2) !important;
}
>>> .el-input--prefix .el-input__inner {
  border: 1px solid var(--border-1);
  border-radius: 8px;
  background: var(--background-10);
}
>>> .el-table__empty-text {
  display: none;
  height: 0;
}
>>> .el-table__empty-block {
  height: 0 !important;
  min-height: 0;
}
>>> .el-tooltip__popper.is-dark,
>>> .el-tooltip__popper.is-light,
>>> .el-tooltip__popper {
  background: white !important;
}
>>> .el-tooltip__popper.is-light {
  background: white !important;
}
>>> .el-input__inner {
  border-radius: 28px;
  height: 50px !important;
}
</style>
